$(document).on('turbolinks:load', function(){
	if($('.flash').get(0)){
		setTimeout(function(){
			$('.flash').attr('data-dismissed', 1)
		}, 4000)
	}
});